import { Offer } from '@wwt/entities/search-response'

import { saveOfferQuery } from '@/entities/offer'
import { reservationStatuses } from '@/shared/types/statuses'

import { getValidatedOffer } from './getValidatedOffer'

export const getSavedOffer = async (offer: Offer) => {
	const status = offer.IDs.status

	/**
	 * NOTE: We always validate offer if status one of reservation
	 */
	if (reservationStatuses.includes(status)) {
		return await getValidatedOffer(offer)
	}

	// TODO: need to refactor for better optimization
	return await saveOfferQuery(offer)
}
